import { rest } from 'msw';

import {
  ACCOUNT_CATEGORY,
  AccountInfo,
  AccountInfoResponse,
  STATUS_TYPE,
} from '.';
import { API_URLS } from '~/configs/api/urls';

const getMyAccountInfoMock = rest.get(
  API_URLS.MEMBER.MY_ACCOUNT,
  async (_, res, ctx) => {
    const response: AccountInfoResponse = {
      accountList: accountList_2_0, // 1.0 or 2.0 선택 가능
      memberStatusList,
      isAvailableOpenAdditionalAccount: false,
    };

    return res(ctx.json(response));
    // return res(ctx.delay(8000), ctx.json(response));
    // return res(ctx.status(401));
  }
);

export default getMyAccountInfoMock;

const accountList_2_0: AccountInfo[] = [
  {
    accountNumber: '1234567890',
    accountKey: '123-123123123123123',
    nickName: '신한은행',
    isIntegratedAccount: true,
    isMain: true,
    hasPassword: true,
    category: ACCOUNT_CATEGORY.종합계좌,
    statusList: [
      {
        type: STATUS_TYPE.국내주식_약정,
        code: 'Y',
      },
      {
        type: STATUS_TYPE.해외주식_약정,
        code: 'Y',
      },
    ],
  },
  {
    accountNumber: '9876543210',
    accountKey: '987-9876543210',
    nickName: '우리은행',
    isIntegratedAccount: false,
    isMain: false,
    hasPassword: true,
    category: ACCOUNT_CATEGORY.주식계좌,
    statusList: [
      {
        type: STATUS_TYPE.국내주식_약정,
        code: 'Y',
      },
      {
        type: STATUS_TYPE.해외주식_약정,
        code: 'Y',
      },
    ],
  },
];

const accountList_1_0: AccountInfo[] = [];

const memberStatusList = [
  {
    type: STATUS_TYPE.선물하기_약정,
    code: 'Y',
  },
  {
    type: STATUS_TYPE.소수점매매_약정,
    code: 'Y',
  },
];
